/**
 * Component Name Map
 * Maps component_code to human-readable title for display in SitemapCanvas.
 * Generated from server/src/services/ai/component-catalog.js
 */
const COMPONENT_NAMES = {
  // Common
  HEADER_01: "Navigation Header",
  FOOTER_01: "Standard Footer",

  // Hero
  HERO_01: "Hero Center CTA",
  HERO_02: "Hero Split Image",
  HERO_03: "Split Hero with Dual CTAs",
  HERO_04: "Newsletter Signup Hero",
  HERO_05: "Hero Video Background",
  HERO_06: "Hero with Top Image",
  HERO_07: "Centered Hero Dual CTA",
  HERO_08: "Centered Hero Solid BG",

  // About
  ABOUT_01: "About Introduction",
  ABOUT_02: "About with Bullet Points",
  ABOUT_03: "About with Feature Cards",
  ABOUT_04: "About Mission Vision",
  ABOUT_05: "About with Stats Grid",
  ABOUT_06: "About Page Hero",
  ABOUT_07: "About with Gradient BG",
  ABOUT_08: "About with Stats Highlights",

  // Services
  SERVICES_01: "Services Grid",
  SERVICES_02: "Services List",

  // Features
  FEATURES_01: "Features Grid",
  FEATURES_02: "Features with Image",
  FEATURES_03: "Features Icon Cards",
  FEATURES_05: "Features Image Showcase",
  FEATURES_06: "Features Zigzag Layout",

  // Testimonials
  TESTIMONIAL_01: "Testimonial Carousel",
  TESTIMONIAL_02: "Testimonial Grid",
  TESTIMONIAL_03: "Before/After Testimonials",

  // Contact
  CONTACT_01: "Contact Form",
  CONTACT_02: "Contact with Info",
  CONTACT_03: "Contact with Map",
  CONTACT_04: "Contact with Side Info",
  CONTACT_05: "Centered Contact Form",
  CONTACT_06: "Dark Contact Form",

  // CTA
  CTA_01: "CTA Banner",
  CTA_02: "CTA with Image",
  CTA_03: "CTA Split Layout",
  CTA_05: "CTA Full-Width BG",

  // FAQ
  FAQ_01: "FAQ Accordion",
  FAQ_02: "FAQ Split Layout",
  FAQ_03: "FAQ Grid Cards",
  FAQ_05: "FAQ Numbered Cards",

  // Pricing
  PRICING_01: "Pricing Cards",

  // Stats
  STATS_01: "Statistics Counter",
  STATS_02: "Centered Stats",

  // Logos
  LOGO_01: "Client Logos",
  LOGOS_02: "Logo Grid Cards",
  LOGOS_03: "Logo Banner Stats",
  LOGOS_04: "Logo Split Section",
  LOGOS_05: "Logo Row with Names",

  // Content
  CONTENT_01: "Content Block",
  CONTENT_02: "Two Column Content",
  CONTENT_03: "Content with Quote",
  CONTENT_04: "Numbered Process Steps",
  CONTENT_05: "Vertical Timeline Steps",
  CONTENT_06: "Featured Content Block",

  // Newsletter
  NEWSLETTER_01: "Newsletter Signup",

  // Map
  MAP_01: "Location Map",

  // Team
  TEAM_01: "Team Grid",

  // Gallery
  GALLERY_01: "Image Gallery",
  GALLERY_02: "Portfolio Showcase",
  GALLERY_03: "Gallery with Filters",
  GALLERY_04: "Case Study Gallery",
  GALLERY_05: "Before & After Gallery",
  GALLERY_06: "Featured Spotlight",

  // Banner
  BANNER_01: "Image Banner",
  BANNER_02: "Split Banner",

  // Image Text
  IMAGE_TEXT_01: "Image Left Text Right",
  IMAGE_TEXT_02: "Image Right Text Left",

  // Hours
  HOURS_01: "Business Hours",
  HOURS_02: "Hours with Contact Info",
  HOURS_03: "Hours Grid Cards",

  // Menu
  MENU_01: "Menu / Price List",

  // --- KALE Theme ---
  KALE_HEADER_01: "Bold Agency Navigation",
  KALE_FOOTER_01: "Bold Agency Dark Footer",
  KALE_HERO_01: "Creative Agency Split Hero",
  KALE_ABOUT_01: "Why Choose Us with Stats",
  KALE_SERVICES_01: "Expandable Service Cards",
  KALE_FEATURES_01: "Numbered Feature Cards",
  KALE_TESTIMONIALS_01: "Client Quote Cards",
  KALE_CONTACT_01: "Split Layout Contact",
  KALE_CTA_01: "Bold Full-Width CTA",
  KALE_FAQ_01: "Dark Accordion FAQ",
  KALE_PRICING_01: "Three Tier Pricing",
  KALE_STATS_01: "Full-Width Stats Bar",
  KALE_CONTENT_01: "Split Content with Steps",
  KALE_NEWSLETTER_01: "Newsletter Signup",
  KALE_MAP_01: "Agency Location Map",
  KALE_TEAM_01: "Team with Social Links",
  KALE_PROJECTS_01: "Project Showcase Grid",
  KALE_HOURS_01: "Business Hours Display",
  KALE_MENU_01: "Service Menu Pricing",

  // --- CLIARO Theme ---
  CLIARO_HEADER_01: "Clean SaaS Navigation",
  CLIARO_FOOTER_01: "Modern SaaS Footer",
  CLIARO_HERO_01: "SaaS Hero with Dashboard",
  CLIARO_ABOUT_01: "About with Overlay Stats",
  CLIARO_SERVICES_01: "Workflow Automation",
  CLIARO_FEATURES_01: "Smart Feature Grid",
  CLIARO_TESTIMONIALS_01: "Star Rating Testimonials",
  CLIARO_CONTACT_01: "Split Contact Form",
  CLIARO_CTA_01: "Workflow CTA Showcase",
  CLIARO_FAQ_01: "Dark Accordion FAQ",
  CLIARO_PRICING_01: "Three-Tier Pricing",
  CLIARO_STATS_01: "Full-Width Stats",
  CLIARO_CONTENT_01: "How We Work Process",
  CLIARO_NEWSLETTER_01: "Newsletter Signup",
  CLIARO_MAP_01: "Agency Location Map",
  CLIARO_TEAM_01: "Team with Social Links",
  CLIARO_GALLERY_01: "Portfolio Hover Grid",
  CLIARO_HOURS_01: "Studio Hours Display",
  CLIARO_MENU_01: "Service Menu Pricing",

  // --- STYLIST Theme ---
  STYLIST_HEADER_01: "Elegant Navigation",
  STYLIST_FOOTER_01: "Elegant Dark Footer",
  STYLIST_HERO_01: "Luxury Split Hero",
  STYLIST_ABOUT_01: "About with Story",
  STYLIST_SERVICES_01: "Arch-Shaped Service Cards",
  STYLIST_FEATURES_01: "Features with Hover",
  STYLIST_TESTIMONIAL_01: "Quote Decoration Cards",
  STYLIST_CONTACT_01: "Contact Split Panel",
  STYLIST_CTA_01: "Elegant Dark CTA",
  STYLIST_FAQ_01: "Styled FAQ Accordion",
  STYLIST_PRICING_01: "Elegant Pricing Cards",
  STYLIST_STATS_01: "Stats with Dividers",
  STYLIST_CONTENT_01: "Our Approach Block",
  STYLIST_NEWSLETTER_01: "Elegant Newsletter",
  STYLIST_MAP_01: "Elegant Studio Location",
  STYLIST_TEAM_01: "Refined Portrait Cards",
  STYLIST_GALLERY_01: "Elegant Portfolio Grid",
  STYLIST_HOURS_01: "Refined Hours Display",
  STYLIST_MENU_01: "Elegant Service Menu",

  // --- ZYPGO Theme ---
  ZYPGO_HEADER_01: "Dark Tech Header",
  ZYPGO_FOOTER_01: "Dark Tech Footer",
  ZYPGO_HERO_01: "Dark Tech Product Hero",
  ZYPGO_ABOUT_01: "Dark Tech About",
  ZYPGO_SERVICES_01: "Dark Tech Services",
  ZYPGO_FEATURES_01: "Dark Tech Features Grid",
  ZYPGO_TESTIMONIAL_01: "Dark Tech Testimonials",
  ZYPGO_CONTACT_01: "Dark Tech Contact",
  ZYPGO_CTA_01: "Dark Tech CTA",
  ZYPGO_FAQ_01: "Dark Tech FAQ",
  ZYPGO_PRICING_01: "Dark Tech Pricing",
  ZYPGO_STATS_01: "Dark Tech Stats Bar",
  ZYPGO_CONTENT_01: "Dark Tech Process Block",
  ZYPGO_NEWSLETTER_01: "Dark Glass Newsletter",
  ZYPGO_MAP_01: "Dark Tech Location",
  ZYPGO_TEAM_01: "Dark Tech Team Grid",
  ZYPGO_GALLERY_01: "Dark Tech Portfolio",
  ZYPGO_HOURS_01: "Dark Glass Hours",
  ZYPGO_MENU_01: "Dark Tech Price List",
};

export default COMPONENT_NAMES;
